
export const isTg = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('tg');
}